module.exports = __webpack_public_path__ + "img/b_logo_3.aca13f93.png";